// angular.module('HeroPRO').filter('pcNumberFormat',


export default function PCNumberFormatFilter() {
    return function (number) {
        if (/^[0-9.]+$/.test(number)) { // check if string contains digits
            // if it's a number, trim
            return parseFloat(number).toFixed(2);
        }

        // If it's not a number, return
        return number;
    };
}



// WEBPACK FOOTER //
// ./src/app/productCenter/filters/numberFormatFilter.js